<template>
  <section style="height: 100%">
    <el-container style="height: 100%;background: #FFFFFF">
      <el-aside width="200px">
        <div style="padding-top: 10px;">
          <el-button class="search-btn" size="small" type="main" icon="el-icon-folder-add" @click="handleAreaAdd">新增区域</el-button>
          <div style="overflow:auto;">
            <el-tree
              :data="treeData"
              node-key="id"
              default-expand-all
              :expand-on-click-node="false"
              style="margin-top:10px;display: inline-block;min-width: 100%;">
                <span class="custom-tree-node" slot-scope="{ node, data }" @click="handleNodeClick(node, data)">
                  <span v-if="data.pid===0" style="color:#07438A"><i class="el-icon-map-location"></i> {{ data.name }}</span>
                  <span v-else>{{ data.name }}</span>
                  <span class="el-ic" style="display:inline-block">
                    <el-button
                      type="text"
                      icon="el-icon-plus"
                      @click="() => appendArea(node, data)">
                    </el-button>
                    <el-button
                      type="text"
                      icon="el-icon-edit"
                      @click="() => editArea(node, data)">
                    </el-button>
                    <el-button
                      type="text"
                      icon="el-icon-delete-solid"
                      style="color:#F56C6C"
                      @click="() => removeArea(node, data)">
                    </el-button>
                  </span>
                </span>
            </el-tree>
          </div>
        </div>
      </el-aside>
      <el-main>
        <div class="search-content">
          <el-row :gutter="20">
            <el-col :span="14">
              <el-button class="search-btn" size="small" type="main" icon="el-icon-plus" @click="handleAdd">新增</el-button>
              <el-button class="search-btn" size="small" type="search" icon="el-icon-search" @click="handleSearchDialog">筛选</el-button>
              <el-button class="search-btn" size="small" type="danger" icon="el-icon-delete-solid" @click="handleBatchDelete">删除</el-button>
            </el-col>
            <el-col :span="10" style="text-align: right;">
              <el-input class="search-input" size="small" placeholder="请输入机构名称" v-model="searchInfo.name"></el-input>
              <el-button class="search-btn" size="small" type="main" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </el-col>
          </el-row>
        </div>
        <div class="table-content">
          <el-table
            :data="tableData"
            v-loading="loading"
            @selection-change="handleSelectionChange"
            border
            style="width: 100%;margin-top:20px">
            <el-table-column
              type="selection"
              width="40">
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称"
              width="150">
            </el-table-column>
            <el-table-column
              prop="code"
              label="机构代码"
              width="180">
            </el-table-column>
            <el-table-column
              prop="areaId"
              label="所属区域"
              :formatter="areaFormatter">
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="创建时间"
              width="200">
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button type="main" size="mini" icon="el-icon-edit-outline" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button type="danger" size="mini" icon="el-icon-delete-solid" @click="handleDel(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="table-page"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageInfo.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageInfo.total">
          </el-pagination>
        </div>
      </el-main>
    </el-container>
    <el-dialog title="机构信息" width="75%" :visible.sync="contentDialogVisible" :close-on-click-modal="false">
      <el-form label-position="right" :rules="orgInfoRules" :ref="formRef" :model="contentInfo" label-width="130px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="机构名称：" prop="name">
              <el-input v-model="contentInfo.name" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构代码：" prop="code">
              <el-input v-model="contentInfo.code" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所属区域：" prop="areaId">
              <el-select v-model="contentInfo.areaId" placeholder="请选择" style="width:100%">
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="contentDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSave">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="区域信息" width="75%" :visible.sync="areaDialogVisible" :close-on-click-modal="false">
      <el-form label-position="right" :rules="areaInfoRules" ref="areaInfoForm" :model="areaInfo" label-width="130px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="区域名称：" prop="name">
              <el-input v-model="areaInfo.name" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="areaDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAreaSave">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="筛选" width="75%" :visible.sync="searchDialogVisible" :close-on-click-modal="false">
      <el-form :model="searchInfo" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="机构名称：">
              <el-input v-model="searchInfo.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构代码：">
              <el-input v-model="searchInfo.code"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="searchDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSearch">搜 索</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
  import Common from '@/components/common/Common'
  import { Table } from '@/components/common/Table'
  import { listPark, addPark, updatePark, deletePark, batchDeletePark, allArea, addArea, updateArea, deleteArea } from '@/api/restapi.js'
  export default {
    mixins: [Table],
    data() {
      return {
        user: Common.user,
        activeArea: 'organ',
        areaDialogVisible: false,
        areaList: [],
        treeData: [],
        orgAreaName: '',
        orgInfoRules: {
          name: [
            { required: true, message: '请填写机构名称', trigger: 'blur' }
          ],
          code: [
            { required: true, message: '请填写机构代码', trigger: 'blur' }
          ],
          areaId: [
            { required: true, message: '请选择所属区域', trigger: 'change' }
          ]
        },
        areaInfo: {
          name: ''
        },
        areaInfoRules: {
          name: [
            { required: true, message: '请填写区域名称', trigger: 'blur' }
          ]
        }
      }
    },
    mounted () {
      this.initAreaList()
    },
    methods: {
      initAreaTree (parentId, area) {
        let list = []
        let childData = area.filter(a=>{return a.parentId === parentId})
        childData.forEach(cd => {
          cd.children = this.initAreaTree(cd.id,area)
          list.push(cd)
        })
        return list
      },
      initAreaList () {
        allArea({}).then(res => {
          if (res.data.code === 0) {
            this.areaList = res.data.data
            this.treeData = this.initAreaTree(0,res.data.data)
          }
        })
      },
      searchMethod () {
        return listPark(this.pageInfo.page,this.pageInfo.size, this.searchInfo)
      },
      beforeAdd () {
        this.contentInfo = {
          name: '',
          code: '',
          areaId: this.searchInfo.areaId
        }
      },
      addMethod () {
        return addPark(this.contentInfo)
      },
      updateMethod () {
        return updatePark(this.contentInfo)
      },
      deleteMethod (id) {
        return deletePark(id)
      },
      batchDeleteMethod () {
        return batchDeletePark(this.selectIds)
      },
      areaFormatter (row, col) {
        let name = ''
        for (let i=0;i<this.areaList.length;i++) {
          if (this.areaList[i].id === row.areaId) {
            name = this.areaList[i].name
            break
          }
        }
        return name
      },
      handleAreaAdd () {
        this.areaInfo = {
          name: '',
          parentId: 0
        }
        this.areaDialogVisible = true
      },
      handleAreaSave () {
        if (this.areaInfo.id) {
          updateArea(this.areaInfo.id,this.areaInfo.name,this.areaInfo.parentId).then(res => {
            if (res.data.code === 0) {
              this.areaDialogVisible = false
              this.initAreaTree()
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        }else {
          addArea(this.areaInfo.name, this.areaInfo.parentId).then(res => {
            if (res.data.code === 0) {
              this.areaDialogVisible = false
              this.initAreaTree()
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        }
      },
      handleNodeClick (node, data) {
        this.searchInfo.areaId = data.id
        this.searchList()
      },
      appendArea (node, data) {
        this.areaInfo = {
          name: '',
          parentId: data.id
        }
        this.areaDialogVisible = true
      },
      editArea (node, data) {
        this.areaInfo = {
          id: data.id,
          name: data.name,
          parentId: data.parentId
        }
        this.areaDialogVisible = true
      },
      removeArea (node, data) {
        if (data.children&&data.children.length>0){
          this.$message({
            type: 'error',
            message: '该节点下有子区域'
          })
          return;
        }
        this.$confirm('确认要删除' + data.name, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteArea(data.id).then(res => {
            if (res.data.code === 0) {
              this.initAreaTree()
            }else {
              this.$message({
                type: 'error',
                message: '删除失败'
              })
            }
          })
        })
      }
    }
  }
</script>
<style scoped>
  @import "../style/Table.css";
  .el-aside {
    background: #FFFFFF;
    padding-left: 5px;
    padding-right: 5px;
    border-right: 1px solid #EDEDED;
  }
  .el-main {
    padding: 0;
  }
  .el-tree-node:focus > .el-tree-node__content {
    background-color: rgb(158, 213, 250) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Park.vue